<template>
  <div><p>Jos ne radi - Trazim</p></div>
</template>

<script>
export default {};
</script>

<style>
</style>